<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand fas fa-unlink"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ตัวแทนจำหน่าย :</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'agentCode'"
                  :name="'agentCode'"
                  :select2-options="agentCodeOptions"
                  v-model="agentCode"
                  ref="agentCodeSelect2"
                  @selectChange="agentCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <div class="form-group">
                <label>ข้อมูลปี :</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'year'"
                  :name="'year'"
                  :select2-options="yearOptions"
                  v-model="year"
                  ref="year"
                  @selectChange="agentCodeChange"
                ></select2>
              </div>
            </div>
          </div>

          <div v-if="year && canExportAllAgents && !isShow" class="d-flex justify-content-end align-items-center mb-3">
            <button type="button"
                    class="btn btn-outline-primary"
                    @click.prevent="exportExcelAllAgents"
                    :disabled="isExportingAll">
              <span>
                <i class="fas fa-file-export"></i>
                {{ isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)" }}
              </span>
            </button>
          </div>

          <div v-if="isShow == true" class="kt-section kt-section--first">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h3 class="kt-section__title">
                รายการถังเปล่าหมุนเวียน :
              </h3>
              <div>
                <button type="button"
                        class="btn btn-outline-primary"
                        @click.prevent="exportExcelSelected"
                        :disabled="isExportingSelected">
                  <span>
                    <i class="fas fa-file-export"></i>
                    {{ isExportingSelected ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายที่เลือก)" }}
                  </span>
                </button>
                <button v-if="canExportAllAgents"
                        type="button"
                        class="btn btn-outline-primary ml-2"
                        @click.prevent="exportExcelAllAgents"
                        :disabled="isExportingAll">
                  <span>
                    <i class="fas fa-file-export"></i>
                    {{ isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)" }}
                  </span>
                </button>
              </div>
            </div>
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table table-sm table-striped table-bordered table-hover table-checkable" style="min-width:7800px;">
                    <thead>
                      <tr>
                        <th rowspan="3" scope="rowgroup" class="text-center" width="1%">
                          ลำดับ
                        </th>
                        <th rowspan="3" scope="rowgroup" class="text-center" width="4%">
                          ประเภทสินค้า
                        </th>
                        <th rowspan="3" scope="rowgroup" class="text-center" width="2%">
                          ต้นทุนสินค้า(บาท)
                        </th>
                        <th colspan="60" scope="colgroup" class="text-center">
                          จำนวนถังเปล่าหมุนเวียน (จำนวน) ปี {{ year }}
                        </th>
                        <th rowspan="2" colspan="4" scope="rowgroup" class="text-center" width="6%">
                          รวม
                        </th>
                        <th rowspan="3" scope="rowgroup" class="text-center" width="2%">
                          % ถังหมุนเวียน
                        </th>
                        <th rowspan="3" scope="rowgroup" class="text-center" width="1%">
                          จัดการ
                        </th>
                      </tr>
                      <tr>
                        <th class="text-center" colspan="5" width="7%">มกราคม</th>
                        <th class="text-center" colspan="5" width="7%">กุมภาพันธ์</th>
                        <th class="text-center" colspan="5" width="7%">มีนาคม</th>
                        <th class="text-center" colspan="5" width="7%">เมษายน</th>
                        <th class="text-center" colspan="5" width="7%">พฤษภาคม</th>
                        <th class="text-center" colspan="5" width="7%">มิถุนายน</th>
                        <th class="text-center" colspan="5" width="7%">กรกฎาคม</th>
                        <th class="text-center" colspan="5" width="7%">สิงหาคม</th>
                        <th class="text-center" colspan="5" width="7%">กันยายน</th>
                        <th class="text-center" colspan="5" width="7%">ตุลาคม</th>
                        <th class="text-center" colspan="5" width="7%">พฤศจิกายน</th>
                        <th class="text-center" colspan="5" width="7%">ธันวาคม</th>
                      </tr>
                      <tr>
                        <template v-for="index in 12">
                          <th class="text-center">ยอดยกมา</th>
                          <th class="text-center">รับเข้า</th>
                          <th class="text-center">ส่งคืน</th>
                          <th class="text-center">คงเหลือ</th>
                          <th class="text-center">% ถังหมุนเวียน</th>
                        </template>
                        <th class="text-center">ยอดยกมา</th>
                        <th class="text-center">รับเข้า</th>
                        <th class="text-center">ส่งคืน</th>
                        <th class="text-center">คงเหลือ</th>
                      </tr>
                    </thead>
                    <tbody @change="changeTotal()">
                      <tr v-if="productitems == null || productitems.length == 0">
                        <td
                          v-if="this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])"
                          colspan="69"
                          class="text-muted text-center"
                        >
                          คลิก + เพื่อเพิ่มรายการใหม่
                        </td>
                      </tr>
                      <template v-for="(item, i) in productitems">
                        <product-item-cal-row
                          ref="Items"
                          :key="i"
                          :rowIndex="i"
                          :item="item"
                          :kPIProductType="kPIProductType"
                          :yearSelected="year"
                          @removeItem="onRemoveItemClick"
                        ></product-item-cal-row>
                      </template>
                    </tbody>

                    <tfoot>
                      <tr>
                        <th class="text-center"></th>
                        <th class="text-center">รวมเงิน</th>
                        <th class="text-center">
                          {{ totalCost | currency("฿ ", 2) }}
                        </th>
                        <template v-for="monthIndex in 12">
                          <th v-for="dataIndex in 5" :key="monthIndex + '-' + dataIndex" class="text-center">
                            {{ calculateMonthTotal(monthIndex, dataIndex) }}
                          </th>
                        </template>
                        <th class="text-center">
                          {{ calculateTotalData(1) }}
                        </th>
                        <th class="text-center">
                          {{ calculateTotalData(2) }}
                        </th>
                        <th class="text-center">
                          {{ calculateTotalData(3) }}
                        </th>
                        <th class="text-center">
                          {{ calculateTotalData(4) }}
                        </th>
                        <th class="text-center">
                          {{ calculateTotalPercent() }}
                        </th>
                        <th></th>
                      </tr>
                      <tr>
                        <td
                          colspan="69"
                          v-if="this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])"
                        >
                          <button
                            type="button"
                            class="btn btn-sm btn-brand"
                            @click.prevent="onAddItemClick"
                          >
                            <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                          </button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-12">
            <label class="kt-button"> </label>
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button
          v-if="isShow == true && this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])"
          type="submit"
          class="btn btn-primary"
          data-dismiss="modal"
        >
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import datepicker from "../../../Shared/Datepicker";
import select2 from "../../../Shared/Select2";
import productItemCalRow from "./ProductItemCalRow";
import { exportExcelFromApi } from "../../../Shared/exportExcelHelper";

export default {
  components: {
    select2,
    datepicker,
    productItemCalRow,
  },
  data() {
    var self = this;
    return {
      monthCanEdit: 2, /* Default FEB, configurable */
      kPIProductType: "KPI_PRODUCT_CYCLE",
      isShow: false,
      isExportingSelected: false,
      isExportingAll: false,
      productitems: [],
      productTotalList: [],
      totalCost: 0,
      totalPoductCost: 0,
      totalProductCostOfMonth: 0,
      i: 0,
      agentCode: null,
      year: new Date().getFullYear(),
      agentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      yearOptions: {
        placeholder: "กรุณาเลือก",
        data: [
          {
            id: new Date().getFullYear(),
            text: new Date().getFullYear(),
            data: null,
          },
          {
            id: new Date().getFullYear() - 1,
            text: new Date().getFullYear() - 1,
            data: null,
          },
        ],
      },
    };
  },
  computed: {
    canExportAllAgents() {
      return this.$root.canShow(['super_admin', 'ADMIN_5S', 'ADVISOR_5S', 'TEAM_5S']);
    },
  },
  methods: {
    initializeData() {
      return Array(12).fill().map(() => ({
        data1: null,
        data2: null,
        data3: null,
        data4: null,
        data5: null,
      }));
    },
    calculateMonthTotal(monthIndex, dataIndex) {
      if (dataIndex === 5) {
        const totalData1 = this.productitems.reduce((acc, item) => acc + item.data[monthIndex - 1]['data1'], 0);
        const totalData2 = this.productitems.reduce((acc, item) => acc + item.data[monthIndex - 1]['data2'], 0);
        const totalData3 = this.productitems.reduce((acc, item) => acc + item.data[monthIndex - 1]['data3'], 0);
        const totalPercent = ((totalData3 / (totalData1 + totalData2)) * 100).toFixed(2);
        if(!(totalPercent == Number.POSITIVE_INFINITY || totalPercent == Number.NEGATIVE_INFINITY) && !isNaN(parseFloat(totalPercent))){
          return totalPercent;
        }else{
          return 0;
        }
      } else {
        return this.productitems.reduce((acc, item) => acc + item.data[monthIndex - 1]['data' + dataIndex], 0);
      }
    },
    calculateTotalData(dataIndex) {
      let total = 0;
      for (let monthIndex = 1; monthIndex <= 12; monthIndex++) {
        total += this.calculateMonthTotal(monthIndex, dataIndex);
      }
      return total;
    },
    calculateTotalPercent() {
      let totalData1 = this.calculateTotalData(1);
      let totalData2 = this.calculateTotalData(2);
      let totalData3 = this.calculateTotalData(3);
      let totalPercent = ((totalData3 / (totalData1 + totalData2)) * 100).toFixed(2);
      if(!(totalPercent == Number.POSITIVE_INFINITY || totalPercent == Number.NEGATIVE_INFINITY) && !isNaN(parseFloat(totalPercent))){
        return totalPercent;
      }else{
        return 0;
      }
    },
    onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var listProductCode = [];
      this.productitems.forEach((element) => {
        listProductCode.push(element.productCode);
      });
      this.productitems.push({
        productCode: null,
        productCost: 0,
        data: this.initializeData(),
        isDisableRow: false,
        isDisableProduct: false,
        listProductCode: listProductCode,
      });
      },
      isDisableRow() {
          var date = new Date();
          var monthNo = date.getMonth() + 1;
          var yearNo = date.getFullYear();

          let isDisable = false;

          if (this.year < yearNo) { /* Previous Year */

              if (monthNo <= this.monthCanEdit) {
                  isDisable = false; // < ภายในเดือนที่ระบุใน config ให้แก้ไขได้
              } else {
                  isDisable = true;
              }

          } else { /* Current Year */
              isDisable = false;
          }
          return isDisable;
      },
    onRemoveItemClick(index, delItem) {
      this.productitems.splice(index, 1);
      for (let i = 0; i < this.productitems.length; i++) {}
      this.changeTotal();
    },
    agentCodeChange() {
      let self = this;
      let router = this.$router;
      // CR-KPI Issue#4: hide Selected button if no agent picked (or agent cleared)
      if (!self.agentCode) {
        self.isShow = false;
        return;
      }
      self.isShow = true;
      self.productitems = [];
      axios({
        method: "post",
        url: "/Api/KPIProduct/getAccessory",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year,
        },
      })
        .then(function(response) {
          if (response.status == 200) {
            if (response.data != null && response.data.length > 0) {
              for (let i = 0; i < response.data.length; i++) {
                var item = response.data[i];
                let kpiData = [];
                for (let j = 1; j < item.monthView.length; j++) {
                  let totalData1 =  item.monthView[j].monthQty !== null ? parseInt(item.monthView[j].monthQty) : null;
                  let totalData2 =  item.monthView[j].monthQtyReceive !== null ? parseInt(item.monthView[j].monthQtyReceive) : null;
                  let totalData3 =  item.monthView[j].monthQtyReturn !== null ? parseInt(item.monthView[j].monthQtyReturn) : null;
                  let totalData4 = null;
                  let totalPercent = null;
                  if(totalData2 === null || totalData3 === null){
                    totalData1 = null
                  }
                  if(totalData1 !== null && totalData2 !== null && totalData3 !== null)
                  {
                    totalData4 = (totalData1 + totalData2) - totalData3;
                    if (totalData1 === 0 && totalData2 === 0) {
                      totalPercent = 0;
                    }else{
                      totalPercent = ((totalData3 / (totalData1 + totalData2)) * 100).toFixed(2);
                      if(!isNaN(parseFloat(totalPercent))){
                        totalPercent = parseFloat(totalPercent);
                      }else{
                        totalPercent =  0;
                      }
                    }
                  }
                  kpiData.push({
                    data1: totalData1,
                    data2: totalData2,
                    data3: totalData3,
                    data4: totalData4,
                    data5: parseFloat(totalPercent),
                  });
                }
                self.productitems.push({
                  productCode: item.productCode,
                    productCost: item.productCost,
                  //isDisableRow: false,
                  isDisableRow: self.isDisableRow(),
                  isDisableProduct: true,
                  data: kpiData,
                  productCodeOptionsData: {
                    id: item.productCode,
                    text: item.productName + " [" + item.productCode + "]",
                    data: null,
                  },
                });

                setTimeout(function() {
                  self.$refs.Items[i].$refs.productCode.setSelectedData(
                    self.productitems[i].productCodeOptionsData
                  );
                  self.changeTotal();
                }, 100);
              }
              self.isShow = true;
            } else {
              self.changeTotal();
            }
          } else {
            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
            router.go(-1);
            self.isShow = false;
          }
        })
        .catch(function(error) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้",
            "error"
          );
          router.go(-1);
          self.isShow = false;
        })
        .then(function() {
          KTApp.unblockPage();
        });
    },
    changeTotal() {
      this.totalCost = 0;
      this.productitems.forEach((e) => {
        this.totalCost = this.totalCost + Number(e.productCost);
      });
    },
    async exportExcelSelected() {
      if (this.isExportingSelected) return;
      if (!this.year) {
        Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
        return;
      }
      this.isExportingSelected = true;
      try {
        await exportExcelFromApi(
          "/Api/KPIProduct/Export/ProductCycle",
          { year: this.year, agentCode: this.agentCode || null },
          "รายงาน_ถังเปล่าหมุนเวียน.xlsx",
          this.$root.user && this.$root.user.access_token
        );
      } catch (err) {
        console.error("[KPI Export Selected]", err);
        const msg = (err.response && err.response.statusText) || err.message || "Export ล้มเหลว";
        Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });
      } finally {
        this.isExportingSelected = false;
      }
    },
    async exportExcelAllAgents() {
      if (this.isExportingAll) return;
      if (!this.year) {
        Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
        return;
      }
      this.isExportingAll = true;
      try {
        await exportExcelFromApi(
          "/Api/KPIProduct/Export/ProductCycle/AllAgents",
          { year: this.year },
          "รายงาน_ถังเปล่าหมุนเวียน_ทุกตัวแทน.xlsx",
          this.$root.user && this.$root.user.access_token
        );
      } catch (err) {
        console.error("[KPI Export All]", err);
        const msg = (err.response && err.response.statusText) || err.message || "Export ล้มเหลว";
        Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });
      } finally {
        this.isExportingAll = false;
      }
    },
    formSubmit: function(e) {
      let self = this;
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }
      if (!(this.$root.canShow(["ADMIN_5S"]) || this.$root.canShow(["JOB_AGENT_KPI"]))) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "คุณไม่ได้รับสิทธิในการแก้ไขข้อมูล",
          "warning"
        );
        return false;
      }
      if(self.agentCode === null || self.agentCode == ""){
        Swal.fire(
            "เกิดข้อผิดพลาด",
            "กรุณาเลือก ตัวแทนจำหน่าย",
            "warning"
          );
        return false;
      }
      if(self.productitems.length < 1){
        Swal.fire(
            "เกิดข้อผิดพลาด",
            "กรุณาเพิ่มรายการถังเปล่าหมุนเวียน",
            "warning"
          );
        return false;
      }
      for (let i = 0; i < self.productitems.length; i++) {
        if (self.productitems[i].productCost == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนต้นทุนสินค้า", "warning");
          return false;
        }
        let isDataEntered = false;
        const item = self.productitems[i];
        for (let monthIndex = 1; monthIndex <= 12; monthIndex++) {
          if ((item.data[monthIndex - 1]['data1'] !== "" && item.data[monthIndex - 1]['data1'] !== null) || 
              (item.data[monthIndex - 1]['data2'] !== "" && item.data[monthIndex - 1]['data2'] !== null) || 
              (item.data[monthIndex - 1]['data3'] !== "" && item.data[monthIndex - 1]['data3'] !== null)
          ) {
            isDataEntered = true;
            break;
          }
        }
        if (!isDataEntered) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนถังเปล่าหมุนเวียน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
          return false;
        }
      }
      for (let i = 0; i < self.productitems.length; i++) {
        const item = self.productitems[i];
        for (let monthIndex = 1; monthIndex <= 12; monthIndex++) {
          if (((item.data[monthIndex - 1]['data1'] !== "" && item.data[monthIndex - 1]['data1'] !== null) && (item.data[monthIndex - 1]['data2'] === null || item.data[monthIndex - 1]['data3'] === null)) || 
              ((item.data[monthIndex - 1]['data2'] !== "" && item.data[monthIndex - 1]['data2'] !== null) && (item.data[monthIndex - 1]['data1'] === null || item.data[monthIndex - 1]['data3'] === null)) || 
              ((item.data[monthIndex - 1]['data3'] !== "" && item.data[monthIndex - 1]['data3'] !== null) && (item.data[monthIndex - 1]['data1'] === null || item.data[monthIndex - 1]['data2'] === null))
          ) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนของเดือน " + monthIndex + " ให้ครบถ้วน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
            return false;
          }
        }
      }
      if (self.year == new Date().getFullYear()) {
        var date = new Date();
        var checkmonth = date.getMonth() + 1;
        for (let i = 0; i < self.productitems.length; i++) {
          let isDataEmpty = false;
          const item = self.productitems[i];
          for (let monthIndex = 1; monthIndex <= checkmonth; monthIndex++) {
            if (
                ((item.data[monthIndex - 1]['data1'] === "" || item.data[monthIndex - 1]['data1'] === null) || 
                (item.data[monthIndex - 1]['data2'] === "" || item.data[monthIndex - 1]['data2'] === null) || 
                (item.data[monthIndex - 1]['data3'] === "" || item.data[monthIndex - 1]['data3'] === null))
            ) {
              isDataEmpty = true;
              break;
            }
          }
          if (isDataEmpty) {
            Swal.fire(
            "เกิดข้อผิดพลาด",
            "กรุณากรอกข้อมูลให้ครบทุกเดือนจนถึงเดือนปัจจุบัน ถ้าไม่มีจำนวนให้ใส่เลข 0",
            "warning"
          );
          return false;
          }
        }
      }
      if (self.year < new Date().getFullYear()) {
        for (let i = 0; i < self.productitems.length; i++) {
          let isDataEmpty = false;
          const item = self.productitems[i];
          for (let monthIndex = 1; monthIndex <= 12; monthIndex++) {
            if ((item.data[monthIndex - 1]['data1'] === "" || item.data[monthIndex - 1]['data1'] === null) || 
                (item.data[monthIndex - 1]['data2'] === "" || item.data[monthIndex - 1]['data2'] === null) || 
                (item.data[monthIndex - 1]['data3'] === "" || item.data[monthIndex - 1]['data3'] === null)
            ) {
              isDataEmpty = true;
              break;
            }
          }
          if (isDataEmpty) {
            Swal.fire(
            "เกิดข้อผิดพลาด",
            "กรุณากรอกจำนวนสินค้าให้ครบในทุกเดือน เนื่องจากเป็นการกรอกข้อมูลย้อนหลังปีปัจจุบัน ถ้าไม่มีจำนวนให้ใส่เลข 0",
            "warning"
          );
          return false;
          }
        }
      }
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      var sItems = [];
      self.productitems.forEach((element) => {
        let kpiData = [];
        element.data.forEach((elementData) => {
          kpiData.push({
            Qty: elementData.data1,
            QtyReceive: elementData.data2,
            QtyReturn: elementData.data3,
          });
        });
        sItems.push({
          ProductCode: element.productCode,
          ProductCost: element.productCost,
          MonthQtyData: kpiData,
        });
      });
      axios({
        method: "post",
        url: "/Api/KPIProduct",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year,
          KPIItem: sItems,
        },
      })
      .then(function(response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(
            function() {
              self.agentCodeChange();
            }
          );
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
    },
  },
  async mounted() {
    let self = this;
    $(this.$refs.form).validate().settings.ignore = ":hidden";

    const res = await axios.get('/Api/KPIProduct/kpiconfig');
    this.monthCanEdit = res.data.monthCanEdit;
  },
};
</script>

<style lang="scss">
  .table thead th, .table thead td {
    vertical-align: middle !important;
  }
</style>


// WEBPACK FOOTER //
// App/Components/KPI/Products/ProductCycle.vue